function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogoutIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.7 5.9c-.2-.2-.4-.2-.4-.2-.4 0-.9.4-.9.9 0 .2.2.4.2.4 2.8 2.4 3 6.7.6 9.5s-6.7 3-9.5.6c-1.5-1.3-2.4-3-2.4-5s.9-3.9 2.4-5.2c.4-.2.4-.9 0-1.1-.2-.4-.9-.4-1.1 0-1.9 1.5-3 3.9-3 6.3 0 4.5 3.7 8.4 8.2 8.4s8.4-3.7 8.4-8.2c.5-2.6-.6-4.9-2.5-6.4m-5.4 6.9c.4 0 .9-.4.9-.9V4.3c0-.4-.4-.9-.9-.9-.4 0-.9.4-.9.9v7.5c.2.7.4 1 .9 1",
  style: {
    fill: "#e02424"
  }
}));
export default SvgLogoutIcon;